<template>
	<div>
		<loading :active.sync="isLoading" :can-cancel="false" :color="'#e99a60'" :is-full-page="true"></loading>
		<NavBar :showMenu="true" />
		<main role="main">
			<div class="container">
				<div class="row">
					<div class="col-md-12">
						<form role="form" @submit.prevent="submit">
							<div class="row">
								<div class="col-md-12">
									<h5>Dados Pessoais</h5>
									<div class="form-group">
										<label>Nome Completo</label>
										<input
											type="text"
											class="form-control"
											:disabled="true"
											:class="{ 'is-invalid': $v.form.nome.$error, 'is-valid': !$v.form.nome.$invalid }"
											v-model.trim="$v.form.nome.$model"
											autocomplete="off"
											placeholder="Digite o seu Nome Completo"
										/>
										<div class="invalid-feedback" v-if="!$v.form.nome.minLength">
											O Nome Completo deve conter no mínimo
											<strong>10 caracteres</strong>
											.
										</div>
										<div class="invalid-feedback" v-if="!$v.form.nome.required">
											O
											<strong>Nome Completo</strong>
											é obrigatório.
										</div>
									</div>
									<div class="form-group">
										<label>Endereço</label>
										<input
											type="text"
											class="form-control"
											:disabled="isLoading"
											:class="{ 'is-invalid': $v.form.endereco.$error, 'is-valid': !$v.form.endereco.$invalid }"
											v-model.trim="$v.form.endereco.$model"
											autocomplete="off"
											placeholder="Digite o seu endereço"
										/>
										<div class="invalid-feedback" v-if="!$v.form.endereco.minLength">
											O seu endereço deve conter no mínimo 10 caracteres.
										</div>
										<div class="invalid-feedback" v-if="!$v.form.endereco.required">
											O
											<strong>Endereço</strong>
											é obrigatório.
										</div>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-4">
									<div class="form-group">
										<label>Estado</label>
										<select
											class="form-control"
											:disabled="isLoading"
											:class="{ 'is-invalid': $v.form.uf.$error, 'is-valid': !$v.form.uf.$invalid }"
											v-model="form.uf"
										>
											<option disabled value>Selecione...</option>
											<option v-for="uf in list" v-bind:key="uf.sigla" v-bind:value="uf.sigla">{{ uf.sigla }}</option>
										</select>
										<div class="invalid-feedback" v-if="$v.form.uf.$error && !$v.form.uf.required">
											Escolha um
											<strong>Estado</strong>
											.
										</div>
									</div>
								</div>
								<div class="col-md-4">
									<div class="form-group">
										<label>Cidade</label>
										<input
											type="text"
											class="form-control"
											:disabled="isLoading"
											:class="{ 'is-invalid': $v.form.cidade.$error, 'is-valid': !$v.form.cidade.$invalid }"
											v-model.trim="$v.form.cidade.$model"
											autocomplete="off"
											placeholder="Digite o seu endereço"
										/>
										<div class="invalid-feedback" v-if="$v.form.cidade.$error && !$v.form.cidade.required">
											Informe uma
											<strong>Cidade</strong>
											.
										</div>
									</div>
								</div>
								<div class="col-md-4">
									<div class="form-group">
										<label>CEP</label>
										<input
											type="text"
											:disabled="isLoading"
											:class="{ 'is-invalid': $v.form.cep.$error, 'is-valid': !$v.form.cep.$invalid }"
											class="form-control"
											placeholder="99999-999"
											v-model="$v.form.cep.$model"
											autocomplete="off"
											v-mask="['#####-###']"
										/>
										<div class="invalid-feedback" v-if="$v.form.cep.$error && !$v.form.cep.minLength">
											CEP inválido.
										</div>
										<div class="invalid-feedback" v-if="$v.form.cep.$error && !$v.form.cep.required">
											Campo obrigatório.
										</div>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-6">
									<div class="form-group">
										<label>Sexo</label>
										<select
											class="form-control"
											:disabled="isLoading"
											:class="{ 'is-invalid': $v.form.sexo.$error, 'is-valid': !$v.form.sexo.$invalid }"
											v-model="form.sexo"
										>
											<option disabled value>Selecione...</option>
											<option value="M">Masculino</option>
											<option value="F">Feminino</option>
										</select>
										<div
											class="invalid-feedback"
											v-if="$v.form.sexo.$error && !$v.form.sexo.$pending && !$v.form.sexo.required"
										>
											Campo obrigatório.
										</div>
									</div>
								</div>
								<div class="col-md-6">
									<div class="form-group">
										<label>Telefone</label>
										<input
											type="tel"
											class="form-control"
											:disabled="isLoading"
											:class="{ 'is-invalid': $v.form.telefone.$error, 'is-valid': !$v.form.telefone.$invalid }"
											placeholder="(99) 99999-9999"
											v-model="$v.form.telefone.$model"
											autocomplete="off"
											v-mask="['(##) ####-####', '(##) #####-####']"
										/>
										<div class="invalid-feedback" v-if="!$v.form.telefone.required">Campo obrigatório.</div>
										<div class="invalid-feedback" v-if="!$v.form.telefone.minLength">
											Insira um número de telefone válido.
										</div>
									</div>
								</div>
								<div class="col-md-12">
									<label>E-mail</label>
									<input
										type="text"
										:disabled="isLoading"
										class="form-control"
										:class="{ 'is-invalid': $v.form.email.$error, 'is-valid': !$v.form.email.$invalid }"
										v-model.trim="$v.form.email.$model"
										autocomplete="off"
									/>
									<div
										class="invalid-feedback"
										v-if="$v.form.email.$error && !$v.form.email.$pending && !$v.form.email.required"
									>
										Campo obrigatório.
									</div>
									<div class="invalid-feedback" v-if="!$v.form.email.$pending && !$v.form.email.email">
										Informe um
										<strong>e-mail</strong>
										válido.
									</div>
									<div class="invalid-feedback" v-if="!$v.form.email.$pending && !$v.form.email.isUnique">
										O
										<strong>e-mail</strong>
										informado já foi cadastrado por outro usuário.
									</div>
								</div>
							</div>
							<hr />
							<div class="row">
								<div class="col-md-12">
									<h5>Dados Profissionais</h5>
									<div class="form-group">
										<label>Profissão</label>
										<input
											type="text"
											class="form-control"
											:class="{ 'is-invalid': $v.form.profissao.$error, 'is-valid': !$v.form.profissao.$invalid }"
											:disabled="isLoading"
											v-model.trim="$v.form.profissao.$model"
											autocomplete="off"
											placeholder="Digite a sua profissão"
										/>
										<div class="invalid-feedback" v-if="!$v.form.profissao.required">Campo obrigatório.</div>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-4">
									<div class="form-group">
										<label>Formação</label>
										<select
											class="form-control"
											:disabled="isLoading"
											v-model="$v.form.formacao.$model"
											:class="{ 'is-invalid': $v.form.formacao.$error, 'is-valid': !$v.form.formacao.$invalid }"
										>
											<option disabled value>Selecione...</option>
											<option value="G">Graduado</option>
											<option value="M">Mestre</option>
											<option value="D">Doutor</option>
											<option value="PD">Pós-Doutor</option>
										</select>
										<div class="invalid-feedback" v-if="!$v.form.formacao.required">Campo obrigatório.</div>
									</div>
								</div>
								<div class="col-md-4">
									<div class="form-group">
										<label>Instituição</label>
										<input
											type="text"
											class="form-control"
											:class="{
												'is-invalid': $v.form.instituicao.$error,
												'is-valid': !$v.form.instituicao.$invalid,
											}"
											:disabled="isLoading"
											v-model.trim="$v.form.instituicao.$model"
											autocomplete="off"
											placeholder="Nome da instituição"
										/>
										<div class="invalid-feedback" v-if="$v.form.instituicao.$error && !$v.form.instituicao.required">
											Campo obrigatório.
										</div>
									</div>
								</div>
								<div class="col-md-4">
									<div class="form-group">
										<label>Departamento do Curso</label>
										<input
											type="text"
											class="form-control"
											:class="{
												'is-invalid': $v.form.departamento.$error,
												'is-valid': !$v.form.departamento.$invalid,
											}"
											:disabled="isLoading"
											v-model.trim="$v.form.departamento.$model"
											autocomplete="off"
											placeholder="Nome do departamento"
										/>
										<div class="invalid-feedback" v-if="!$v.form.departamento.required">Campo obrigatório.</div>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<div class="form-group">
										<label>Currículo Lattes</label>
										<input
											type="text"
											class="form-control"
											:class="{ 'is-invalid': $v.form.lattes.$error, 'is-valid': !$v.form.lattes.$invalid }"
											:disabled="isLoading"
											v-model.trim="$v.form.lattes.$model"
											autocomplete="off"
											placeholder="Informe o link do seu currículo na plataforma Lattes"
										/>
										<div class="invalid-feedback" v-if="!$v.form.lattes.required">Campo obrigatório.</div>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12 text-center">
									<button type="submit" class="btn btn-primary btn-flat" :disabled="isLoading || $v.form.$invalid">
										<span v-if="!isLoading">Atualizar informações</span>
										<span v-if="isLoading">
											<i class="fa fa-circle-o-notch fa-spin"></i>
											Atualizando... aguarde!
										</span>
									</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		</main>
	</div>
</template>

<script>
import NavBar from '@/components/NavBar.vue';
import Loading from 'vue-loading-overlay';
import { required, minLength, email } from 'vuelidate/lib/validators';
import 'vue-loading-overlay/dist/vue-loading.css';
import { baseApiUrl } from '@/global';

const axios = require('axios');
const lodash = require('lodash');
/* eslint-disable */
export default {
	name: 'login',
	data: function() {
		return {
			isLoading: false,
			form: {},
			ufs: [
				{ nome: 'Acre', sigla: 'AC' },
				{ nome: 'Alagoas', sigla: 'AL' },
				{ nome: 'Amapá', sigla: 'AP' },
				{ nome: 'Amazonas', sigla: 'AM' },
				{ nome: 'Bahia', sigla: 'BA' },
				{ nome: 'Ceará', sigla: 'CE' },
				{ nome: 'Distrito Federal', sigla: 'DF' },
				{ nome: 'Espírito Santo', sigla: 'ES' },
				{ nome: 'Goiás', sigla: 'GO' },
				{ nome: 'Maranhão', sigla: 'MA' },
				{ nome: 'Mato Grosso', sigla: 'MT' },
				{ nome: 'Mato Grosso do Sul', sigla: 'MS' },
				{ nome: 'Minas Gerais', sigla: 'MG' },
				{ nome: 'Pará', sigla: 'PA' },
				{ nome: 'Paraíba', sigla: 'PB' },
				{ nome: 'Paraná', sigla: 'PR' },
				{ nome: 'Pernambuco', sigla: 'PE' },
				{ nome: 'Piauí', sigla: 'PI' },
				{ nome: 'Rio de Janeiro', sigla: 'RJ' },
				{ nome: 'Rio Grande do Norte', sigla: 'RN' },
				{ nome: 'Rio Grande do Sul', sigla: 'RS' },
				{ nome: 'Rondônia', sigla: 'RO' },
				{ nome: 'Roraima', sigla: 'RR' },
				{ nome: 'Santa Catarina', sigla: 'SC' },
				{ nome: 'São Paulo', sigla: 'SP' },
				{ nome: 'Sergipe', sigla: 'SE' },
				{ nome: 'Tocantins', sigla: 'TO' },
			],
			cidades: [],
		};
	},
	components: {
		NavBar,
		Loading,
	},
	validations: {
		form: {
			nome: {
				required,
				minLength: minLength(10),
			},
			endereco: {
				required,
				minLength: minLength(10),
			},
			uf: {
				required,
			},
			cidade: {
				required,
			},
			cep: {
				required,
				minLength: minLength(9),
			},
			telefone: {
				required,
				minLength: minLength(14),
			},
			sexo: {
				required,
			},
			email: {
				required,
				email,
				isUnique(value) {
					if (value === '') return true;
					return new Promise((resolve, reject) => {
						axios
							.get(baseApiUrl + 'api/socios/verificaEmail?email=' + this.form.email + '&id=' + this.$auth.user().data.id)
							.then((response) => {
								resolve(response.data.response);
							})
							.catch(() => {
								reject();
							});
					});
				},
			},
			profissao: {
				required,
			},
			formacao: {
				required,
			},
			instituicao: {
				required,
			},
			departamento: {
				required,
			},
			lattes: {
				required,
			},
		},
	},
	methods: {
		socio() {
			this.isLoading = true;
			axios
				.get(baseApiUrl + 'api/socios/dados?id=' + this.$auth.user().data.id)
				.then((response) => {
					this.isLoading = false;
					this.form = response.data;
				})
				.catch(() => {
					this.isLoading = false;
					this.$toasted.global.defaultError({
						mensagem: 'Não foi possível conectar ao servidor. Verifique a sua conexão e tente novamente.',
					});
				});
		},
		getCidades() {
			this.form.cidade = '';
			axios.get('https://servicodados.ibge.gov.br/api/v1/localidades/estados/' + this.form.uf.id + '/municipios').then((response) => {
				this.cidades = response.data;
			});
		},
		submit() {
			this.$v.$touch();
			if (!this.$v.$invalid) {
				this.isLoading = true;
				axios
					.post(baseApiUrl + 'api/socios/update', { id: this.$auth.user().data.id, data: this.form })
					.then((response) => {
						if (response.data == true) {
							this.$toasted.global.defaultSuccess({
								mensagem: 'Suas informações foram atualizadas com sucesso.',
							});
							this.$router.push('/home');
						} else {
							this.$toasted.global.defaultError({
								mensagem: 'Não foi possível atualizar o seu cadastro. Tente novamente mais tarde.',
							});
						}
					})
					.catch(() => {
						this.$toasted.global.defaultError({
							mensagem: 'Não foi possível atualizar o seu cadastro. Tente novamente mais tarde.',
						});
					})
					.finally(() => {
						this.isLoading = false;
					});
			}
		},
	},
	mounted() {
		this.socio();
	},
	computed: {
		list() {
			return lodash.orderBy(this.ufs, 'sigla');
		},
	},
};
</script>
